export function SkipLink() {
  return (
    <a
      className='sr-only z-50 rounded-md bg-background px-4 py-2 focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:outline-none focus:ring-2 focus:ring-ring'
      href='#main-content'
    >
      Skip to content
    </a>
  )
}
